module.exports = __webpack_public_path__ + "img/mund.da8f0ab3.png";